import Cliente from "../Cliente";

export const get = () => {
  return Cliente.setBearerToken()
    .getCliente()
    .get(`${process.env.REACT_APP_API_URL}config/`);
};
